import { Grid, Typography } from "@mui/material";
import { useResponsive } from "../../../Modulo_Responsive/Hooks/useResponsive";
import { Link } from "react-router-dom";

const Tarjeta_Blog_Blog2 = ({ titulo, descripcion, imagen, link }) => {
    const { sCell } = useResponsive();

    return (
        <Grid
            container
            direction="column"
            size={{ xs: 12, sm: 12, md: 12 }}
            component={Link}
            to={link}
            aria-label={`Leer artículo: ${titulo}`}
            sx={{
                cursor: "pointer",
                textDecoration: "none",
                transition: "transform 0.3s ease",
                "&:hover": {
                    transform: "translateY(-8px)",
                },
            }}
        >
            {imagen && (
                <Grid container justifyContent="flex-start" alignItems="flex-start"
                      size={{ xs: 12, sm: 12, md: 12 }}>
                    <img
                        src={imagen}
                        alt={`Imagen ilustrativa sobre ${titulo}`}
                        style={{ width: "100%", height: "220px", objectFit: "cover" }}
                    />
                </Grid>
            )}

            <Grid container data-aos="fade-up" data-aos-duration="1200"
                  data-aos-easing="ease-out" size={{ xs: 12, sm: 12, md: 12 }}>

                <Grid container data-aos="fade-up" data-aos-duration="1000"
                      data-aos-easing="ease-out"
                      sx={{ pt: 1, minHeight: sCell ? 0 : 50 }}
                      size={{ xs: 12, sm: 12, md: 12 }}>
                    <Typography
                        component="h3"
                        variant="h3"
                        sx={{ fontSize: 20, fontWeight: 500, lineHeight: 1.4, color: "#223B59" }}
                    >
                        {titulo}
                    </Typography>
                </Grid>

                {descripcion && (
                    <Grid container
                          sx={{ mt: 2, flexGrow: 1, minHeight: sCell ? "0px" : "50px" }}
                          size={{ xs: 12, sm: 12, md: 12 }}>
                        <Typography
                            component="p"
                            sx={{ fontSize: 16, fontWeight: 400, lineHeight: 1.4, color: "black" }}
                        >
                            {descripcion}
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};

export default Tarjeta_Blog_Blog2;